<template>
  <section
    ref="scrollingLogoBandSection"
    :class="{ 'section-builder-scrolling-logo-band': true }"
  >
    <GeneralTheme :theme="configuration">
      <div
        :class="{
          'mask container mx-auto': !fullWidthContent,
          'fluid-container mask px-5 lg:px-10': fullWidthContent,
        }"
      >
        <ScrollingLogoBand
          v-if="scrollingLogoBandData"
          :data="scrollingLogoBandData"
          :is-visible="isVisible"
        />
      </div>
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import ScrollingLogoBand from '~/components/Atoms/ScrollingLogoBand/ScrollingLogoBand.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderScrollingLogoBand } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';
import { useIntersectionObserver } from '@vueuse/core';

const props = defineProps<SectionBuilderScrollingLogoBand>();
const { getResolvedScrollingLogoBand } = useRefsStore();
const scrollingLogoBandData = await getResolvedScrollingLogoBand(
  props.scrollingLogoBand?.reference?._ref
);

const scrollingLogoBandSection = useTemplateRef<HTMLElement>('scrollingLogoBandSection');
const isVisible = ref(false);

useIntersectionObserver(
  scrollingLogoBandSection,
  ([entry]) => {
    isVisible.value = isVisible.value || (entry?.isIntersecting ?? false);
  },
  {
    threshold: 0.01,
    rootMargin: '150px',
  }
);
</script>

<style lang="scss" scoped>
.section-builder-scrolling-logo-band {
  .mask {
    mask-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 15%,
      rgba(0, 0, 0, 1) 85%,
      rgba(0, 0, 0, 0) 100%
    );
  }
  @media (min-width: 1024px) and (max-width: 1699px) {
    .fluid-container {
      max-width: 100%;
    }
  }
  @media (min-width: 1700px) {
    .fluid-container {
      max-width: 1600px;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>
